// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"section-wrapper-module--section-wrapper--1JArh section-module--marginShort--3Bx9k"};